/*
 * @Autor: GeekMzy
 * @Date: 2022-01-20 17:14:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-29 14:33:43
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\api\api.js
 * @Author: desktop-1llkr2o
 */
/* eslint-disable */
import axios from '../service/http'
import qs from 'qs'
// import { Message } from 'element-ui'

let domain = process.env.VUE_APP_BASE_URL + 'api/basin'
export const getDomain = () => {
  return domain
}
export const setDomain = ($domain) => {
  domain = $domain
}
export const request = (method, url, body, queryParameters, form, config) => {
  return new Promise((resolve, reject) => {
    method = method.toLowerCase()
    let keys = Object.keys(queryParameters)
    let queryUrl = url
    if (keys.length > 0) {
      queryUrl = url + '?' + qs.stringify(queryParameters)
    }
    // let queryUrl = url+(keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
    let response
    if (body) {
      response = axios[method](queryUrl, body, config)
    } else if (method === 'get') {
      response = axios[method](
        queryUrl,
        {
          params: form,
        },
        config
      )
    } else {
      response = axios[method](queryUrl, qs.stringify(form), config)
    }
    response.then((res) => {
      if (res.data.msg === 'OK' && res.data.code === 200) resolve(res.data.data)
      else {
        // Message.error(res.data.msg)
        resolve(null)
      }
    })
  })
}
/*
 *视频通话
 */
export const callCreate = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/callCreate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['channelNo'] !== undefined) {
    queryParameters['channelNo'] = parameters['channelNo']
  }
  if (parameters['userId'] !== undefined) {
    queryParameters['userId'] = parameters['userId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const callStatus = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/getStatus'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['channelNo'] !== undefined) {
    queryParameters['channelNo'] = parameters['channelNo']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
/*==========================================================
 *                    本文档描述了接口定义规范
 ==========================================================*/
/**
 * 区域概况
 * request: getAreaInfoUsingGET
 * url: getAreaInfoUsingGETURL
 * method: getAreaInfoUsingGET_TYPE
 * raw_url: getAreaInfoUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getAreaInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hkgk/areaInfo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAreaInfoUsingGET_RAW_URL = function () {
  return '/screen/hkgk/areaInfo'
}
export const getAreaInfoUsingGET_TYPE = function () {
  return 'get'
}
export const getAreaInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hkgk/areaInfo'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 区域概况--主要河流一览表
 * request: getRiverOverviewListUsingGET
 * url: getRiverOverviewListUsingGETURL
 * method: getRiverOverviewListUsingGET_TYPE
 * raw_url: getRiverOverviewListUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getRiverOverviewListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hkgk/riverOverviewList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRiverOverviewListUsingGET_RAW_URL = function () {
  return '/screen/hkgk/riverOverviewList'
}
export const getRiverOverviewListUsingGET_TYPE = function () {
  return 'get'
}
export const getRiverOverviewListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hkgk/riverOverviewList'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 流域岸线--水污染
 * request: getSwrUsingGET
 * url: getSwrUsingGETURL
 * method: getSwrUsingGET_TYPE
 * raw_url: getSwrUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getSwrUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hkgk/swr'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSwrUsingGET_RAW_URL = function () {
  return '/screen/hkgk/swr'
}
export const getSwrUsingGET_TYPE = function () {
  return 'get'
}
export const getSwrUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hkgk/swr'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 流域岸线--水域岸线
 * request: getSyaxUsingGET
 * url: getSyaxUsingGETURL
 * method: getSyaxUsingGET_TYPE
 * raw_url: getSyaxUsingGET_RAW_URL
 * @param ly - 流域名称
 */
export const getSyaxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hkgk/syax'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['ly'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ly'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSyaxUsingGET_RAW_URL = function () {
  return '/screen/hkgk/syax'
}
export const getSyaxUsingGET_TYPE = function () {
  return 'get'
}
export const getSyaxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hkgk/syax'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 流域岸线--水资源
 * request: getSzyUsingGET
 * url: getSzyUsingGETURL
 * method: getSzyUsingGET_TYPE
 * raw_url: getSzyUsingGET_RAW_URL
 * @param ly - 流域名称
 */
export const getSzyUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hkgk/szy'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['ly'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ly'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSzyUsingGET_RAW_URL = function () {
  return '/screen/hkgk/szy'
}
export const getSzyUsingGET_TYPE = function () {
  return 'get'
}
export const getSzyUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hkgk/szy'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 流域水环境统计数
 * request: getWaterEnvironmentUsingGET
 * url: getWaterEnvironmentUsingGETURL
 * method: getWaterEnvironmentUsingGET_TYPE
 * raw_url: getWaterEnvironmentUsingGET_RAW_URL
 * @param ly - 流域
 * @param time - 开始时间
 * @param type - 监测类别
 */
export const getWaterEnvironmentUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hkgk/waterEnvironment'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWaterEnvironmentUsingGET_RAW_URL = function () {
  return '/screen/hkgk/waterEnvironment'
}
export const getWaterEnvironmentUsingGET_TYPE = function () {
  return 'get'
}
export const getWaterEnvironmentUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hkgk/waterEnvironment'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 流域水环境统计--折线图
 * request: getWaterEnvironmentLineChartUsingGET
 * url: getWaterEnvironmentLineChartUsingGETURL
 * method: getWaterEnvironmentLineChartUsingGET_TYPE
 * raw_url: getWaterEnvironmentLineChartUsingGET_RAW_URL
 * @param ly - 流域
 * @param time - 月份（yyyy-MM）
 * @param type - 监测类别
 */
export const getWaterEnvironmentLineChartUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hkgk/waterEnvironmentLineChart'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWaterEnvironmentLineChartUsingGET_RAW_URL = function () {
  return '/screen/hkgk/waterEnvironmentLineChart'
}
export const getWaterEnvironmentLineChartUsingGET_TYPE = function () {
  return 'get'
}
export const getWaterEnvironmentLineChartUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hkgk/waterEnvironmentLineChart'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 站点当前水质获取
 * request: autoSiteLastWaterLevelUsingGET
 * url: autoSiteLastWaterLevelUsingGETURL
 * method: autoSiteLastWaterLevelUsingGET_TYPE
 * raw_url: autoSiteLastWaterLevelUsingGET_RAW_URL
 * @param ly - ly
 */
export const autoSiteLastWaterLevelUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/autoSiteLastWaterLevel'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const autoSiteLastWaterLevelUsingGET_RAW_URL = function () {
  return '/screen/home/autoSiteLastWaterLevel'
}
export const autoSiteLastWaterLevelUsingGET_TYPE = function () {
  return 'get'
}
export const autoSiteLastWaterLevelUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/autoSiteLastWaterLevel'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河长工作下拉框
 * request: getHzgzDropBoxUsingGET
 * url: getHzgzDropBoxUsingGETURL
 * method: getHzgzDropBoxUsingGET_TYPE
 * raw_url: getHzgzDropBoxUsingGET_RAW_URL
 */
export const getHzgzDropBoxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/getHzgzDropBox'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHzgzDropBoxUsingGET_RAW_URL = function () {
  return '/screen/home/getHzgzDropBox'
}
export const getHzgzDropBoxUsingGET_TYPE = function () {
  return 'get'
}
export const getHzgzDropBoxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/getHzgzDropBox'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河长调度-年度问题统计 | 巡河问题
 * request: getProblemsUsingGET
 * url: getProblemsUsingGETURL
 * method: getProblemsUsingGET_TYPE
 * raw_url: getProblemsUsingGET_RAW_URL
 * @param date - 月份查询（全年/'各月<01-12>'）
 * @param ly - 流域
 */
export const getProblemsUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/getProblems'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['date'] !== undefined) {
    queryParameters['date'] = parameters['date']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProblemsUsingGET_RAW_URL = function () {
  return '/screen/home/getProblems'
}
export const getProblemsUsingGET_TYPE = function () {
  return 'get'
}
export const getProblemsUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/getProblems'
  if (parameters['date'] !== undefined) {
    queryParameters['date'] = parameters['date']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河库概况-河流统计
 * request: getRiverCountStatisticsInfoUsingGET
 * url: getRiverCountStatisticsInfoUsingGETURL
 * method: getRiverCountStatisticsInfoUsingGET_TYPE
 * raw_url: getRiverCountStatisticsInfoUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getRiverCountStatisticsInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/getRiverCountStatisticsInfo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRiverCountStatisticsInfoUsingGET_RAW_URL = function () {
  return '/screen/home/getRiverCountStatisticsInfo'
}
export const getRiverCountStatisticsInfoUsingGET_TYPE = function () {
  return 'get'
}
export const getRiverCountStatisticsInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/getRiverCountStatisticsInfo'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河长工作-人数统计 | 河长体系
 * request: getRiverLeaderQuantityUsingGET
 * url: getRiverLeaderQuantityUsingGETURL
 * method: getRiverLeaderQuantityUsingGET_TYPE
 * raw_url: getRiverLeaderQuantityUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getRiverLeaderQuantityUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/getRiverLeaderQuantity'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRiverLeaderQuantityUsingGET_RAW_URL = function () {
  return '/screen/home/getRiverLeaderQuantity'
}
export const getRiverLeaderQuantityUsingGET_TYPE = function () {
  return 'get'
}
export const getRiverLeaderQuantityUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/getRiverLeaderQuantity'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河长工作-巡检统计
 * request: getWgyXhInfoListUsingGET
 * url: getWgyXhInfoListUsingGETURL
 * method: getWgyXhInfoListUsingGET_TYPE
 * raw_url: getWgyXhInfoListUsingGET_RAW_URL
 * @param ly - 流域
 * @param type - 人员类别,wgy网格员 hz河长
 */
export const getWgyXhInfoListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/getWgyXhInfoList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWgyXhInfoListUsingGET_RAW_URL = function () {
  return '/screen/home/getWgyXhInfoList'
}
export const getWgyXhInfoListUsingGET_TYPE = function () {
  return 'get'
}
export const getWgyXhInfoListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/getWgyXhInfoList'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 首页河流区域下拉框
 * request: mapAreaSelectUsingGET
 * url: mapAreaSelectUsingGETURL
 * method: mapAreaSelectUsingGET_TYPE
 * raw_url: mapAreaSelectUsingGET_RAW_URL
 */
export const mapAreaSelectUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/mapAreaSelect'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const mapAreaSelectUsingGET_RAW_URL = function () {
  return '/screen/home/mapAreaSelect'
}
export const mapAreaSelectUsingGET_TYPE = function () {
  return 'get'
}
export const mapAreaSelectUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/mapAreaSelect'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 地图下拉导航栏
 * request: mapDropListUsingGET
 * url: mapDropListUsingGETURL
 * method: mapDropListUsingGET_TYPE
 * raw_url: mapDropListUsingGET_RAW_URL
 * @param area - 区域
 */
export const mapDropListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/mapDropList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['area'] !== undefined) {
    queryParameters['area'] = parameters['area']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const mapDropListUsingGET_RAW_URL = function () {
  return '/screen/home/mapDropList'
}
export const mapDropListUsingGET_TYPE = function () {
  return 'get'
}
export const mapDropListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/mapDropList'
  if (parameters['area'] !== undefined) {
    queryParameters['area'] = parameters['area']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 地图点位筛选
 * request: mapfilterUsingGET
 * url: mapfilterUsingGETURL
 * method: mapfilterUsingGET_TYPE
 * raw_url: mapfilterUsingGET_RAW_URL
 * @param keyword - 搜索关键字
 * @param ly - 流域
 * @param positions - 条件(巡河在线/xh_online, 手工监测断面/sgjcdm, 水质自动监测站/szzdjcz,  污水处理厂/wsclc, 重点工业企业/zdgyqy, 规模化畜牧养殖/gmhxmyz, 水产养殖/scyz, 国控站/gkz, 市控站/skz, 一体化站/ythz, 物联站/wlz, 水库/sk,饮用水源地/yysyd),视频监测点位/spjcd,  巡查上报/xcsb, 自动告警/zdgj, 任务交办/rwjb 多个逗号隔开
 * @param timeUnit - 时间周期 d天 w周 m月,只作用于上报、告警、交办的查询
 * @param zjName - 镇街名称
 */
export const mapfilterUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/mapfilter'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['keyword'] !== undefined) {
    queryParameters['keyword'] = parameters['keyword']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['positions'] !== undefined) {
    queryParameters['positions'] = parameters['positions']
  }
  if (parameters['positions'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: positions'))
  }
  if (parameters['timeUnit'] !== undefined) {
    queryParameters['timeUnit'] = parameters['timeUnit']
  }
  if (parameters['zjName'] !== undefined) {
    queryParameters['zjName'] = parameters['zjName']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const mapfilterUsingGET_RAW_URL = function () {
  return '/screen/home/mapfilter'
}
export const mapfilterUsingGET_TYPE = function () {
  return 'get'
}
export const mapfilterUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/mapfilter'
  if (parameters['keyword'] !== undefined) {
    queryParameters['keyword'] = parameters['keyword']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['positions'] !== undefined) {
    queryParameters['positions'] = parameters['positions']
  }
  if (parameters['timeUnit'] !== undefined) {
    queryParameters['timeUnit'] = parameters['timeUnit']
  }
  if (parameters['zjName'] !== undefined) {
    queryParameters['zjName'] = parameters['zjName']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 首页监测数统计
 * request: getMonitorStatisticsUsingGET
 * url: getMonitorStatisticsUsingGETURL
 * method: getMonitorStatisticsUsingGET_TYPE
 * raw_url: getMonitorStatisticsUsingGET_RAW_URL
 * @param type - 统计条件,(szzdjcz水质自动监测站、wsclc污水处理厂、zdgyqy重点工业企业),逗号分隔请求数据
 */
export const getMonitorStatisticsUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/monitorStatistics'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMonitorStatisticsUsingGET_RAW_URL = function () {
  return '/screen/home/monitorStatistics'
}
export const getMonitorStatisticsUsingGET_TYPE = function () {
  return 'get'
}
export const getMonitorStatisticsUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/monitorStatistics'
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 视频监控
 * request: getMonitorVideoUsingGET
 * url: getMonitorVideoUsingGETURL
 * method: getMonitorVideoUsingGET_TYPE
 * raw_url: getMonitorVideoUsingGET_RAW_URL
 */
export const getMonitorVideoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/monitorVideo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMonitorVideoUsingGET_RAW_URL = function () {
  return '/screen/home/monitorVideo'
}
export const getMonitorVideoUsingGET_TYPE = function () {
  return 'get'
}
export const getMonitorVideoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/monitorVideo'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河库概况-水库统计
 * request: totalSkUsingGET
 * url: totalSkUsingGETURL
 * method: totalSkUsingGET_TYPE
 * raw_url: totalSkUsingGET_RAW_URL
 * @param ly - 流域
 */
export const totalSkUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/totalSk'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const totalSkUsingGET_RAW_URL = function () {
  return '/screen/home/totalSk'
}
export const totalSkUsingGET_TYPE = function () {
  return 'get'
}
export const totalSkUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/totalSk'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水环境质量 | 河流水质
 * request: waterAssessmentUsingGET
 * url: waterAssessmentUsingGETURL
 * method: waterAssessmentUsingGET_TYPE
 * raw_url: waterAssessmentUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 时间格式（yyyy-MM）
 * @param type - 监测类型,sgjc手工监测 zdjc自动监测
 */
export const waterAssessmentUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/waterAssessment'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const waterAssessmentUsingGET_RAW_URL = function () {
  return '/screen/home/waterAssessment'
}
export const waterAssessmentUsingGET_TYPE = function () {
  return 'get'
}
export const waterAssessmentUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/waterAssessment'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水环境质量下拉框
 * request: waterAssessmentDropBoxUsingGET
 * url: waterAssessmentDropBoxUsingGETURL
 * method: waterAssessmentDropBoxUsingGET_TYPE
 * raw_url: waterAssessmentDropBoxUsingGET_RAW_URL
 */
export const waterAssessmentDropBoxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/waterAssessmentDropBox'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const waterAssessmentDropBoxUsingGET_RAW_URL = function () {
  return '/screen/home/waterAssessmentDropBox'
}
export const waterAssessmentDropBoxUsingGET_TYPE = function () {
  return 'get'
}
export const waterAssessmentDropBoxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/waterAssessmentDropBox'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水域污染源-统计数据
 * request: waterPollutionStatisticsUsingGET
 * url: waterPollutionStatisticsUsingGETURL
 * method: waterPollutionStatisticsUsingGET_TYPE
 * raw_url: waterPollutionStatisticsUsingGET_RAW_URL
 * @param ly - 流域名称
 */
export const waterPollutionStatisticsUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/waterPollutionStatistics'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const waterPollutionStatisticsUsingGET_RAW_URL = function () {
  return '/screen/home/waterPollutionStatistics'
}
export const waterPollutionStatisticsUsingGET_TYPE = function () {
  return 'get'
}
export const waterPollutionStatisticsUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/waterPollutionStatistics'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河长调度-问题详情(含处理流程)
 * request: wgyWtInfoUsingGET
 * url: wgyWtInfoUsingGETURL
 * method: wgyWtInfoUsingGET_TYPE
 * raw_url: wgyWtInfoUsingGET_RAW_URL
 * @param id - 问题id
 */
export const wgyWtInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/home/wgyWtInfo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const wgyWtInfoUsingGET_RAW_URL = function () {
  return '/screen/home/wgyWtInfo'
}
export const wgyWtInfoUsingGET_TYPE = function () {
  return 'get'
}
export const wgyWtInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/home/wgyWtInfo'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河统计-周期时间(行政级别级联下拉)
 * request: getAdministrativeLevelDateDropBoxUsingGET
 * url: getAdministrativeLevelDateDropBoxUsingGETURL
 * method: getAdministrativeLevelDateDropBoxUsingGET_TYPE
 * raw_url: getAdministrativeLevelDateDropBoxUsingGET_RAW_URL
 * @param type - 周期类型
 */
export const getAdministrativeLevelDateDropBoxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/administrativeLevelDateDropBox'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAdministrativeLevelDateDropBoxUsingGET_RAW_URL = function () {
  return '/screen/hzgz/administrativeLevelDateDropBox'
}
export const getAdministrativeLevelDateDropBoxUsingGET_TYPE = function () {
  return 'get'
}
export const getAdministrativeLevelDateDropBoxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/administrativeLevelDateDropBox'
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河统计-行政级别下拉框
 * request: getAdministrativeLevelDropBoxUsingGET
 * url: getAdministrativeLevelDropBoxUsingGETURL
 * method: getAdministrativeLevelDropBoxUsingGET_TYPE
 * raw_url: getAdministrativeLevelDropBoxUsingGET_RAW_URL
 */
export const getAdministrativeLevelDropBoxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/administrativeLevelDropBox'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAdministrativeLevelDropBoxUsingGET_RAW_URL = function () {
  return '/screen/hzgz/administrativeLevelDropBox'
}
export const getAdministrativeLevelDropBoxUsingGET_TYPE = function () {
  return 'get'
}
export const getAdministrativeLevelDropBoxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/administrativeLevelDropBox'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河统计弹窗--巡查记录
 * request: getHzxhRecordListUsingGET
 * url: getHzxhRecordListUsingGETURL
 * method: getHzxhRecordListUsingGET_TYPE
 * raw_url: getHzxhRecordListUsingGET_RAW_URL
 * @param beginTime - 开始时间
 * @param endTime - 结束时间
 * @param userId - 用户id
 */
export const getHzxhRecordListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getHzxhRecordList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['userId'] !== undefined) {
    queryParameters['userId'] = parameters['userId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHzxhRecordListUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getHzxhRecordList'
}
export const getHzxhRecordListUsingGET_TYPE = function () {
  return 'get'
}
export const getHzxhRecordListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getHzxhRecordList'
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['userId'] !== undefined) {
    queryParameters['userId'] = parameters['userId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河情况统计
 * request: getProblemReportBaseRecordInfoUsingGET
 * url: getProblemReportBaseRecordInfoUsingGETURL
 * method: getProblemReportBaseRecordInfoUsingGET_TYPE
 * raw_url: getProblemReportBaseRecordInfoUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getProblemReportBaseRecordInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getProblemReportBaseRecordInfo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProblemReportBaseRecordInfoUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getProblemReportBaseRecordInfo'
}
export const getProblemReportBaseRecordInfoUsingGET_TYPE = function () {
  return 'get'
}
export const getProblemReportBaseRecordInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getProblemReportBaseRecordInfo'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 镇街考核-获取行政区划对应的考核信息
 * request: getRankingsByXzqhUsingGET
 * url: getRankingsByXzqhUsingGETURL
 * method: getRankingsByXzqhUsingGET_TYPE
 * raw_url: getRankingsByXzqhUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 考核月份（yyyy-MM）
 * @param xzqh - 行政区划
 */
export const getRankingsByXzqhUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getRankingsByXzqh'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters['xzqh'] !== undefined) {
    queryParameters['xzqh'] = parameters['xzqh']
  }
  if (parameters['xzqh'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: xzqh'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRankingsByXzqhUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getRankingsByXzqh'
}
export const getRankingsByXzqhUsingGET_TYPE = function () {
  return 'get'
}
export const getRankingsByXzqhUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getRankingsByXzqh'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['xzqh'] !== undefined) {
    queryParameters['xzqh'] = parameters['xzqh']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 镇街考核-查看考核排名详情弹窗
 * request: getRankingsDetailUsingGET
 * url: getRankingsDetailUsingGETURL
 * method: getRankingsDetailUsingGET_TYPE
 * raw_url: getRankingsDetailUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 考核月份（yyyy-MM）
 */
export const getRankingsDetailUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getRankingsDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRankingsDetailUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getRankingsDetail'
}
export const getRankingsDetailUsingGET_TYPE = function () {
  return 'get'
}
export const getRankingsDetailUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getRankingsDetail'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 镇街考核-获取考核排名列表
 * request: getRankingsListUsingGET
 * url: getRankingsListUsingGETURL
 * method: getRankingsListUsingGET_TYPE
 * raw_url: getRankingsListUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 考核月份（yyyy-MM）
 */
export const getRankingsListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getRankingsList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRankingsListUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getRankingsList'
}
export const getRankingsListUsingGET_TYPE = function () {
  return 'get'
}
export const getRankingsListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getRankingsList'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河统计-河长巡河基础信息统计
 * request: getRiverCruiseBaseStatisticsUsingGET
 * url: getRiverCruiseBaseStatisticsUsingGETURL
 * method: getRiverCruiseBaseStatisticsUsingGET_TYPE
 * raw_url: getRiverCruiseBaseStatisticsUsingGET_RAW_URL
 * @param level - 行政级别 1:部门 2:区级 3:镇街 4:村居
 * @param ly - 流域
 * @param period - 周期(季度或月份):第一季度 或 2022-01
 */
export const getRiverCruiseBaseStatisticsUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getRiverCruiseBaseStatistics'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['level'] !== undefined) {
    queryParameters['level'] = parameters['level']
  }
  if (parameters['level'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: level'))
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['period'] !== undefined) {
    queryParameters['period'] = parameters['period']
  }
  if (parameters['period'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: period'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRiverCruiseBaseStatisticsUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getRiverCruiseBaseStatistics'
}
export const getRiverCruiseBaseStatisticsUsingGET_TYPE = function () {
  return 'get'
}
export const getRiverCruiseBaseStatisticsUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getRiverCruiseBaseStatistics'
  if (parameters['level'] !== undefined) {
    queryParameters['level'] = parameters['level']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['period'] !== undefined) {
    queryParameters['period'] = parameters['period']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 一河一策---目标任务列表信息
 * request: getTargetTaskListUsingGET
 * url: getTargetTaskListUsingGETURL
 * method: getTargetTaskListUsingGET_TYPE
 * raw_url: getTargetTaskListUsingGET_RAW_URL
 * @param beginTime - 任务开始时间:2021
 * @param endTime - 任务结束时间:2025
 * @param ly - 流域
 * @param taskLevel - 任务级别 1:市级  2:区级
 * @param taskType - 目标任务类别--1:水资源保护 2:水域岸线管理保护 3:水污染防治 4:水环境治理 5:水生态修复 6:执法监管
 */
export const getTargetTaskListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getTargetTaskList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['taskLevel'] !== undefined) {
    queryParameters['taskLevel'] = parameters['taskLevel']
  }
  if (parameters['taskType'] !== undefined) {
    queryParameters['taskType'] = parameters['taskType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTargetTaskListUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getTargetTaskList'
}
export const getTargetTaskListUsingGET_TYPE = function () {
  return 'get'
}
export const getTargetTaskListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getTargetTaskList'
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['taskLevel'] !== undefined) {
    queryParameters['taskLevel'] = parameters['taskLevel']
  }
  if (parameters['taskType'] !== undefined) {
    queryParameters['taskType'] = parameters['taskType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 一河一策弹窗
 * request: getTargetTaskStatisticsUsingGET
 * url: getTargetTaskStatisticsUsingGETURL
 * method: getTargetTaskStatisticsUsingGET_TYPE
 * raw_url: getTargetTaskStatisticsUsingGET_RAW_URL
 * @param beginTime - 任务开始时间:2021
 * @param endTime - 任务结束时间:2025
 * @param ly - 流域
 */
export const getTargetTaskStatisticsUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getTargetTaskStatistics'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTargetTaskStatisticsUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getTargetTaskStatistics'
}
export const getTargetTaskStatisticsUsingGET_TYPE = function () {
  return 'get'
}
export const getTargetTaskStatisticsUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getTargetTaskStatistics'
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河统计-未完成巡河列表
 * request: getUnDoRiverPatrolListUsingGET
 * url: getUnDoRiverPatrolListUsingGETURL
 * method: getUnDoRiverPatrolListUsingGET_TYPE
 * raw_url: getUnDoRiverPatrolListUsingGET_RAW_URL
 * @param level - 行政级别 1:部门 2:区级 3:镇街 4:村居
 * @param ly - 流域
 * @param period - 周期(季度或月份):第一季度 或 2022-01
 */
export const getUnDoRiverPatrolListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getUnDoRiverPatrolList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['level'] !== undefined) {
    queryParameters['level'] = parameters['level']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['period'] !== undefined) {
    queryParameters['period'] = parameters['period']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUnDoRiverPatrolListUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getUnDoRiverPatrolList'
}
export const getUnDoRiverPatrolListUsingGET_TYPE = function () {
  return 'get'
}
export const getUnDoRiverPatrolListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getUnDoRiverPatrolList'
  if (parameters['level'] !== undefined) {
    queryParameters['level'] = parameters['level']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['period'] !== undefined) {
    queryParameters['period'] = parameters['period']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河情况统计--弹窗
 * request: getXhInfoPopUsingGET
 * url: getXhInfoPopUsingGETURL
 * method: getXhInfoPopUsingGET_TYPE
 * raw_url: getXhInfoPopUsingGET_RAW_URL
 * @param beginTime - 开始时间
 * @param endTime - 结束时间
 * @param problemStatus - 任务状态, 总数-all 已处理-doing
 * @param zj - 镇街
 */
export const getXhInfoPopUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/getXhInfoPop'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['problemStatus'] !== undefined) {
    queryParameters['problemStatus'] = parameters['problemStatus']
  }
  if (parameters['zj'] !== undefined) {
    queryParameters['zj'] = parameters['zj']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getXhInfoPopUsingGET_RAW_URL = function () {
  return '/screen/hzgz/getXhInfoPop'
}
export const getXhInfoPopUsingGET_TYPE = function () {
  return 'get'
}
export const getXhInfoPopUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/getXhInfoPop'
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['problemStatus'] !== undefined) {
    queryParameters['problemStatus'] = parameters['problemStatus']
  }
  if (parameters['zj'] !== undefined) {
    queryParameters['zj'] = parameters['zj']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河长体系-河流及河长统计
 * request: lyTotalDetailUsingGET
 * url: lyTotalDetailUsingGETURL
 * method: lyTotalDetailUsingGET_TYPE
 * raw_url: lyTotalDetailUsingGET_RAW_URL
 * @param ly - 流域名称
 */
export const lyTotalDetailUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/lyTotalDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const lyTotalDetailUsingGET_RAW_URL = function () {
  return '/screen/hzgz/lyTotalDetail'
}
export const lyTotalDetailUsingGET_TYPE = function () {
  return 'get'
}
export const lyTotalDetailUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/lyTotalDetail'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 一河一策统计
 * request: getOneRiverOnePlanUsingGET
 * url: getOneRiverOnePlanUsingGETURL
 * method: getOneRiverOnePlanUsingGET_TYPE
 * raw_url: getOneRiverOnePlanUsingGET_RAW_URL
 * @param time - 查询时间
 */
export const getOneRiverOnePlanUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/oneRiverOnePlanStatistics'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters['time'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: time'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOneRiverOnePlanUsingGET_RAW_URL = function () {
  return '/screen/hzgz/oneRiverOnePlanStatistics'
}
export const getOneRiverOnePlanUsingGET_TYPE = function () {
  return 'get'
}
export const getOneRiverOnePlanUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/oneRiverOnePlanStatistics'
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 一河一策-任务措施清单类型下拉框
 * request: getOneRiverOnePlanTargetTaskDropBoxUsingGET
 * url: getOneRiverOnePlanTargetTaskDropBoxUsingGETURL
 * method: getOneRiverOnePlanTargetTaskDropBoxUsingGET_TYPE
 * raw_url: getOneRiverOnePlanTargetTaskDropBoxUsingGET_RAW_URL
 */
export const getOneRiverOnePlanTargetTaskDropBoxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/oneRiverOnePlanTargetTaskDropBox'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOneRiverOnePlanTargetTaskDropBoxUsingGET_RAW_URL = function () {
  return '/screen/hzgz/oneRiverOnePlanTargetTaskDropBox'
}
export const getOneRiverOnePlanTargetTaskDropBoxUsingGET_TYPE = function () {
  return 'get'
}
export const getOneRiverOnePlanTargetTaskDropBoxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/oneRiverOnePlanTargetTaskDropBox'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 镇街考核-获取考核排名最新时间
 * request: pmtimeUsingGET
 * url: pmtimeUsingGETURL
 * method: pmtimeUsingGET_TYPE
 * raw_url: pmtimeUsingGET_RAW_URL
 */
export const pmtimeUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/pmtime'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const pmtimeUsingGET_RAW_URL = function () {
  return '/screen/hzgz/pmtime'
}
export const pmtimeUsingGET_TYPE = function () {
  return 'get'
}
export const pmtimeUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/pmtime'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河长体系-弹窗统计
 * request: riverLeaderSystemUsingGET
 * url: riverLeaderSystemUsingGETURL
 * method: riverLeaderSystemUsingGET_TYPE
 * raw_url: riverLeaderSystemUsingGET_RAW_URL
 * @param ly - 流域
 * @param zj - 镇街
 */
export const riverLeaderSystemUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/riverLeaderSystem'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['zj'] !== undefined) {
    queryParameters['zj'] = parameters['zj']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const riverLeaderSystemUsingGET_RAW_URL = function () {
  return '/screen/hzgz/riverLeaderSystem'
}
export const riverLeaderSystemUsingGET_TYPE = function () {
  return 'get'
}
export const riverLeaderSystemUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/riverLeaderSystem'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['zj'] !== undefined) {
    queryParameters['zj'] = parameters['zj']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河统计--巡查记录点击--查看详情
 * request: geWgyRecordInfoUsingGET
 * url: geWgyRecordInfoUsingGETURL
 * method: geWgyRecordInfoUsingGET_TYPE
 * raw_url: geWgyRecordInfoUsingGET_RAW_URL
 * @param id - 巡查记录id
 */
export const geWgyRecordInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/wgyRecordInfo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const geWgyRecordInfoUsingGET_RAW_URL = function () {
  return '/screen/hzgz/wgyRecordInfo'
}
export const geWgyRecordInfoUsingGET_TYPE = function () {
  return 'get'
}
export const geWgyRecordInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/wgyRecordInfo'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 网格员未完成巡河列表接口
 * request: wgyWwcxhListUsingGET
 * url: wgyWwcxhListUsingGETURL
 * method: wgyWwcxhListUsingGET_TYPE
 * raw_url: wgyWwcxhListUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 查询年月(yyyy-MM)
 */
export const wgyWwcxhListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/wgyWwcxhList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const wgyWwcxhListUsingGET_RAW_URL = function () {
  return '/screen/hzgz/wgyWwcxhList'
}
export const wgyWwcxhListUsingGET_TYPE = function () {
  return 'get'
}
export const wgyWwcxhListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/wgyWwcxhList'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 网格员巡河统计接口
 * request: wgyXhUsingGET
 * url: wgyXhUsingGETURL
 * method: wgyXhUsingGET_TYPE
 * raw_url: wgyXhUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 查询年月(yyyy-MM)
 * @param xcfw - 巡查范围
 * @param zj - 镇街
 */
export const wgyXhUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/hzgz/wgyXh'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters['xcfw'] !== undefined) {
    queryParameters['xcfw'] = parameters['xcfw']
  }
  if (parameters['zj'] !== undefined) {
    queryParameters['zj'] = parameters['zj']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const wgyXhUsingGET_RAW_URL = function () {
  return '/screen/hzgz/wgyXh'
}
export const wgyXhUsingGET_TYPE = function () {
  return 'get'
}
export const wgyXhUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/hzgz/wgyXh'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['xcfw'] !== undefined) {
    queryParameters['xcfw'] = parameters['xcfw']
  }
  if (parameters['zj'] !== undefined) {
    queryParameters['zj'] = parameters['zj']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水库点位查询
 * request: getReservoirPointUsingGET
 * url: getReservoirPointUsingGETURL
 * method: getReservoirPointUsingGET_TYPE
 * raw_url: getReservoirPointUsingGET_RAW_URL
 * @param index - 参数: 水库(sk)、中型水库(zx)、小型水库(xx)
 * @param ly - 流域
 */
export const getReservoirPointUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/linkageMap/reservoirPoint'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['index'] !== undefined) {
    queryParameters['index'] = parameters['index']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getReservoirPointUsingGET_RAW_URL = function () {
  return '/screen/linkageMap/reservoirPoint'
}
export const getReservoirPointUsingGET_TYPE = function () {
  return 'get'
}
export const getReservoirPointUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/linkageMap/reservoirPoint'
  if (parameters['index'] !== undefined) {
    queryParameters['index'] = parameters['index']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水文水利点位查询
 * request: getSwslPointUsingGET
 * url: getSwslPointUsingGETURL
 * method: getSwslPointUsingGET_TYPE
 * raw_url: getSwslPointUsingGET_RAW_URL
 * @param ly - 流域名称
 * @param type - 水文水利类型（水文站，水位站，雨量站）
 */
export const getSwslPointUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/linkageMap/swslPoint'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSwslPointUsingGET_RAW_URL = function () {
  return '/screen/linkageMap/swslPoint'
}
export const getSwslPointUsingGET_TYPE = function () {
  return 'get'
}
export const getSwslPointUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/linkageMap/swslPoint'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水域污染源点位查询
 * request: getSywryPointUsingGET
 * url: getSywryPointUsingGETURL
 * method: getSywryPointUsingGET_TYPE
 * raw_url: getSywryPointUsingGET_RAW_URL
 * @param ly - 流域名称
 * @param model - 总数(all),超标(cb),接入(join)
 * @param type - 污水处理厂(wsclc),重点工业企业(zdgyqy)
 */
export const getSywryPointUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/linkageMap/sywryPoint'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['model'] !== undefined) {
    queryParameters['model'] = parameters['model']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['type'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: type'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSywryPointUsingGET_RAW_URL = function () {
  return '/screen/linkageMap/sywryPoint'
}
export const getSywryPointUsingGET_TYPE = function () {
  return 'get'
}
export const getSywryPointUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/linkageMap/sywryPoint'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['model'] !== undefined) {
    queryParameters['model'] = parameters['model']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水文水利点位获取
 * request: getSzyPointUsingGET
 * url: getSzyPointUsingGETURL
 * method: getSzyPointUsingGET_TYPE
 * raw_url: getSzyPointUsingGET_RAW_URL
 * @param ly - 流域名称
 * @param type - 坐标类型, 0全部, 1在线
 * @param zl - 水文水利类型（水文站，水位站，雨量站）
 */
export const getSzyPointUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/linkageMap/szyPoint'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['zl'] !== undefined) {
    queryParameters['zl'] = parameters['zl']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSzyPointUsingGET_RAW_URL = function () {
  return '/screen/linkageMap/szyPoint'
}
export const getSzyPointUsingGET_TYPE = function () {
  return 'get'
}
export const getSzyPointUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/linkageMap/szyPoint'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['zl'] !== undefined) {
    queryParameters['zl'] = parameters['zl']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 监测站点位查询(含手工监测、自动监测的)
 * request: getWaterAssessmentPointUsingGET
 * url: getWaterAssessmentPointUsingGETURL
 * method: getWaterAssessmentPointUsingGET_TYPE
 * raw_url: getWaterAssessmentPointUsingGET_RAW_URL
 * @param category - 类别,手工监测(sgjc),自动监测(zdjc)
 * @param ly - 流域
 * @param model - 达标(db),超标(cb),全部(all)
 * @param type - 国考(g)，市考(s),区考(q),一体化(yth),物联站(wlz)
 */
export const getWaterAssessmentPointUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/linkageMap/waterAssessmentPoint'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['category'] !== undefined) {
    queryParameters['category'] = parameters['category']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['model'] !== undefined) {
    queryParameters['model'] = parameters['model']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['type'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: type'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWaterAssessmentPointUsingGET_RAW_URL = function () {
  return '/screen/linkageMap/waterAssessmentPoint'
}
export const getWaterAssessmentPointUsingGET_TYPE = function () {
  return 'get'
}
export const getWaterAssessmentPointUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/linkageMap/waterAssessmentPoint'
  if (parameters['category'] !== undefined) {
    queryParameters['category'] = parameters['category']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['model'] !== undefined) {
    queryParameters['model'] = parameters['model']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 饮用水源地点位查询
 * request: getYysydPointUsingGET
 * url: getYysydPointUsingGETURL
 * method: getYysydPointUsingGET_TYPE
 * raw_url: getYysydPointUsingGET_RAW_URL
 * @param ly - 流域名称
 */
export const getYysydPointUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/linkageMap/yysydPoint'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getYysydPointUsingGET_RAW_URL = function () {
  return '/screen/linkageMap/yysydPoint'
}
export const getYysydPointUsingGET_TYPE = function () {
  return 'get'
}
export const getYysydPointUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/linkageMap/yysydPoint'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染溯源--超标因子下拉
 * request: getCbFactorUsingGET
 * url: getCbFactorUsingGETURL
 * method: getCbFactorUsingGET_TYPE
 * raw_url: getCbFactorUsingGET_RAW_URL
 */
export const getCbFactorUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/cbFactorDropDown'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCbFactorUsingGET_RAW_URL = function () {
  return '/screen/mapPop/cbFactorDropDown'
}
export const getCbFactorUsingGET_TYPE = function () {
  return 'get'
}
export const getCbFactorUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/cbFactorDropDown'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 一体化自动站弹窗--监测数据
 * request: getMonitorDataListUsingGET
 * url: getMonitorDataListUsingGETURL
 * method: getMonitorDataListUsingGET_TYPE
 * raw_url: getMonitorDataListUsingGET_RAW_URL
 * @param begin - 监测时间
 * @param factor - 因子编码
 * @param frequency - 数据周期, H-时均，D-日均
 * @param mn - 设备编码
 */
export const getMonitorDataListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/getAutoSiteMonitorDataList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['begin'] !== undefined) {
    queryParameters['begin'] = parameters['begin']
  }
  if (parameters['begin'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: begin'))
  }
  if (parameters['factor'] !== undefined) {
    queryParameters['factor'] = parameters['factor']
  }
  if (parameters['factor'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: factor'))
  }
  if (parameters['frequency'] !== undefined) {
    queryParameters['frequency'] = parameters['frequency']
  }
  if (parameters['frequency'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: frequency'))
  }
  if (parameters['mn'] !== undefined) {
    queryParameters['mn'] = parameters['mn']
  }
  if (parameters['mn'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mn'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMonitorDataListUsingGET_RAW_URL = function () {
  return '/screen/mapPop/getAutoSiteMonitorDataList'
}
export const getMonitorDataListUsingGET_TYPE = function () {
  return 'get'
}
export const getMonitorDataListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/getAutoSiteMonitorDataList'
  if (parameters['begin'] !== undefined) {
    queryParameters['begin'] = parameters['begin']
  }
  if (parameters['factor'] !== undefined) {
    queryParameters['factor'] = parameters['factor']
  }
  if (parameters['frequency'] !== undefined) {
    queryParameters['frequency'] = parameters['frequency']
  }
  if (parameters['mn'] !== undefined) {
    queryParameters['mn'] = parameters['mn']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 网格基本信息查询
 * request: getGridBaseInfoUsingGET
 * url: getGridBaseInfoUsingGETURL
 * method: getGridBaseInfoUsingGET_TYPE
 * raw_url: getGridBaseInfoUsingGET_RAW_URL
 * @param id - 网格编号id
 */
export const getGridBaseInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/gridBaseInfo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getGridBaseInfoUsingGET_RAW_URL = function () {
  return '/screen/mapPop/gridBaseInfo'
}
export const getGridBaseInfoUsingGET_TYPE = function () {
  return 'get'
}
export const getGridBaseInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/gridBaseInfo'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 河道支流弹窗信息
 * request: getRiverZLUsingGET
 * url: getRiverZLUsingGETURL
 * method: getRiverZLUsingGET_TYPE
 * raw_url: getRiverZLUsingGET_RAW_URL
 */
export const getRiverZLUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/hdzlDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRiverZLUsingGET_RAW_URL = function () {
  return '/screen/mapPop/hdzlDetail'
}
export const getRiverZLUsingGET_TYPE = function () {
  return 'get'
}
export const getRiverZLUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/hdzlDetail'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 问题详情(含处理流程)
 * request: getProblemDetailByIdUsingGET
 * url: getProblemDetailByIdUsingGETURL
 * method: getProblemDetailByIdUsingGET_TYPE
 * raw_url: getProblemDetailByIdUsingGET_RAW_URL
 * @param id - 问题id
 */
export const getProblemDetailByIdUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/problemDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProblemDetailByIdUsingGET_RAW_URL = function () {
  return '/screen/mapPop/problemDetail'
}
export const getProblemDetailByIdUsingGET_TYPE = function () {
  return 'get'
}
export const getProblemDetailByIdUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/problemDetail'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 任务来源下拉
 * request: getProblemSourceUsingGET
 * url: getProblemSourceUsingGETURL
 * method: getProblemSourceUsingGET_TYPE
 * raw_url: getProblemSourceUsingGET_RAW_URL
 */
export const getProblemSourceUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/problemSource'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProblemSourceUsingGET_RAW_URL = function () {
  return '/screen/mapPop/problemSource'
}
export const getProblemSourceUsingGET_TYPE = function () {
  return 'get'
}
export const getProblemSourceUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/problemSource'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水产养殖弹窗信息
 * request: getScyzDetailUsingGET
 * url: getScyzDetailUsingGETURL
 * method: getScyzDetailUsingGET_TYPE
 * raw_url: getScyzDetailUsingGET_RAW_URL
 * @param id - id
 */
export const getScyzDetailUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/scyzDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getScyzDetailUsingGET_RAW_URL = function () {
  return '/screen/mapPop/scyzDetail'
}
export const getScyzDetailUsingGET_TYPE = function () {
  return 'get'
}
export const getScyzDetailUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/scyzDetail'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 手工监测断面弹窗信息
 * request: waterAssessmentByIdUsingGET
 * url: waterAssessmentByIdUsingGETURL
 * method: waterAssessmentByIdUsingGET_TYPE
 * raw_url: waterAssessmentByIdUsingGET_RAW_URL
 * @param id - 断面id
 */
export const waterAssessmentByIdUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/sgjcdmDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const waterAssessmentByIdUsingGET_RAW_URL = function () {
  return '/screen/mapPop/sgjcdmDetail'
}
export const waterAssessmentByIdUsingGET_TYPE = function () {
  return 'get'
}
export const waterAssessmentByIdUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/sgjcdmDetail'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水库弹窗信息
 * request: getSkDetailUsingGET
 * url: getSkDetailUsingGETURL
 * method: getSkDetailUsingGET_TYPE
 * raw_url: getSkDetailUsingGET_RAW_URL
 * @param id - id
 */
export const getSkDetailUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/skDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSkDetailUsingGET_RAW_URL = function () {
  return '/screen/mapPop/skDetail'
}
export const getSkDetailUsingGET_TYPE = function () {
  return 'get'
}
export const getSkDetailUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/skDetail'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 视频告警数据(演示暂用)
 * request: getSpgjDataUsingGET
 * url: getSpgjDataUsingGETURL
 * method: getSpgjDataUsingGET_TYPE
 * raw_url: getSpgjDataUsingGET_RAW_URL
 * @param name - 视频设备名称
 */
export const getSpgjDataUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/spgjData'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSpgjDataUsingGET_RAW_URL = function () {
  return '/screen/mapPop/spgjData'
}
export const getSpgjDataUsingGET_TYPE = function () {
  return 'get'
}
export const getSpgjDataUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/spgjData'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水文水利-点位详情(含数据图数据)
 * request: getSwslDetailAndGraphUsingGET
 * url: getSwslDetailAndGraphUsingGETURL
 * method: getSwslDetailAndGraphUsingGET_TYPE
 * raw_url: getSwslDetailAndGraphUsingGET_RAW_URL
 * @param indexCode - 站点编码
 */
export const getSwslDetailAndGraphUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/swslDetailAndGraph'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['indexCode'] !== undefined) {
    queryParameters['indexCode'] = parameters['indexCode']
  }
  if (parameters['indexCode'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: indexCode'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSwslDetailAndGraphUsingGET_RAW_URL = function () {
  return '/screen/mapPop/swslDetailAndGraph'
}
export const getSwslDetailAndGraphUsingGET_TYPE = function () {
  return 'get'
}
export const getSwslDetailAndGraphUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/swslDetailAndGraph'
  if (parameters['indexCode'] !== undefined) {
    queryParameters['indexCode'] = parameters['indexCode']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水文水利-数据图表
 * request: getSwslGraphUsingGET
 * url: getSwslGraphUsingGETURL
 * method: getSwslGraphUsingGET_TYPE
 * raw_url: getSwslGraphUsingGET_RAW_URL
 * @param factor - 因子
 * @param indexCode - 站点编码
 * @param tm - 时间
 * @param zl - 水文水利类型（全部，水文站，水位站，雨量站）
 */
export const getSwslGraphUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/swslGraph'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['factor'] !== undefined) {
    queryParameters['factor'] = parameters['factor']
  }
  if (parameters['factor'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: factor'))
  }
  if (parameters['indexCode'] !== undefined) {
    queryParameters['indexCode'] = parameters['indexCode']
  }
  if (parameters['indexCode'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: indexCode'))
  }
  if (parameters['tm'] !== undefined) {
    queryParameters['tm'] = parameters['tm']
  }
  if (parameters['tm'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tm'))
  }
  if (parameters['zl'] !== undefined) {
    queryParameters['zl'] = parameters['zl']
  }
  if (parameters['zl'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: zl'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSwslGraphUsingGET_RAW_URL = function () {
  return '/screen/mapPop/swslGraph'
}
export const getSwslGraphUsingGET_TYPE = function () {
  return 'get'
}
export const getSwslGraphUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/swslGraph'
  if (parameters['factor'] !== undefined) {
    queryParameters['factor'] = parameters['factor']
  }
  if (parameters['indexCode'] !== undefined) {
    queryParameters['indexCode'] = parameters['indexCode']
  }
  if (parameters['tm'] !== undefined) {
    queryParameters['tm'] = parameters['tm']
  }
  if (parameters['zl'] !== undefined) {
    queryParameters['zl'] = parameters['zl']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 手工监测(水源地)断面弹窗信息-断面因子基准线
 * request: dmyzDatumLineUsingGET
 * url: dmyzDatumLineUsingGETURL
 * method: dmyzDatumLineUsingGET_TYPE
 * raw_url: dmyzDatumLineUsingGET_RAW_URL
 * @param code - 因子
 * @param pjjbn - 标准水质类别
 * @param stlx - 水体类型
 */
export const dmyzDatumLineUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/waterAssessment/dmyzDatumLine'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['code'] !== undefined) {
    queryParameters['code'] = parameters['code']
  }
  if (parameters['code'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: code'))
  }
  if (parameters['pjjbn'] !== undefined) {
    queryParameters['pjjbn'] = parameters['pjjbn']
  }
  if (parameters['pjjbn'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pjjbn'))
  }
  if (parameters['stlx'] !== undefined) {
    queryParameters['stlx'] = parameters['stlx']
  }
  if (parameters['stlx'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stlx'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const dmyzDatumLineUsingGET_RAW_URL = function () {
  return '/screen/mapPop/waterAssessment/dmyzDatumLine'
}
export const dmyzDatumLineUsingGET_TYPE = function () {
  return 'get'
}
export const dmyzDatumLineUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/waterAssessment/dmyzDatumLine'
  if (parameters['code'] !== undefined) {
    queryParameters['code'] = parameters['code']
  }
  if (parameters['pjjbn'] !== undefined) {
    queryParameters['pjjbn'] = parameters['pjjbn']
  }
  if (parameters['stlx'] !== undefined) {
    queryParameters['stlx'] = parameters['stlx']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 网格对应网格员巡河轨迹
 * request: getWgyWgXhGjUsingGET
 * url: getWgyWgXhGjUsingGETURL
 * method: getWgyWgXhGjUsingGET_TYPE
 * raw_url: getWgyWgXhGjUsingGET_RAW_URL
 * @param id - 网格编号id
 * @param period - period
 */
export const getWgyWgXhGjUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/wgyWgXhGj'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['period'] !== undefined) {
    queryParameters['period'] = parameters['period']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWgyWgXhGjUsingGET_RAW_URL = function () {
  return '/screen/mapPop/wgyWgXhGj'
}
export const getWgyWgXhGjUsingGET_TYPE = function () {
  return 'get'
}
export const getWgyWgXhGjUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/wgyWgXhGj'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['period'] !== undefined) {
    queryParameters['period'] = parameters['period']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 网格员巡河轨迹记录
 * request: getWgyXhTrackRecordUsingGET
 * url: getWgyXhTrackRecordUsingGETURL
 * method: getWgyXhTrackRecordUsingGET_TYPE
 * raw_url: getWgyXhTrackRecordUsingGET_RAW_URL
 * @param period - 周期 d天 w周 m月
 * @param userId - 用户id
 */
export const getWgyXhTrackRecordUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/wgyXhTrackRecord'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['period'] !== undefined) {
    queryParameters['period'] = parameters['period']
  }
  if (parameters['period'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: period'))
  }
  if (parameters['userId'] !== undefined) {
    queryParameters['userId'] = parameters['userId']
  }
  if (parameters['userId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWgyXhTrackRecordUsingGET_RAW_URL = function () {
  return '/screen/mapPop/wgyXhTrackRecord'
}
export const getWgyXhTrackRecordUsingGET_TYPE = function () {
  return 'get'
}
export const getWgyXhTrackRecordUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/wgyXhTrackRecord'
  if (parameters['period'] !== undefined) {
    queryParameters['period'] = parameters['period']
  }
  if (parameters['userId'] !== undefined) {
    queryParameters['userId'] = parameters['userId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 无人机飞行详情数据
 * request: getWrjFlightDetailByIdUsingGET
 * url: getWrjFlightDetailByIdUsingGETURL
 * method: getWrjFlightDetailByIdUsingGET_TYPE
 * raw_url: getWrjFlightDetailByIdUsingGET_RAW_URL
 * @param id - id
 */
export const getWrjFlightDetailByIdUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/wrjFlight'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWrjFlightDetailByIdUsingGET_RAW_URL = function () {
  return '/screen/mapPop/wrjFlight'
}
export const getWrjFlightDetailByIdUsingGET_TYPE = function () {
  return 'get'
}
export const getWrjFlightDetailByIdUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/wrjFlight'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染溯源--点位统计
 * request: getWrsyPointListUsingPOST
 * url: getWrsyPointListUsingPOSTURL
 * method: getWrsyPointListUsingPOST_TYPE
 * raw_url: getWrsyPointListUsingPOST_RAW_URL
 * @param wrsyQuery - wrsyQuery
 */
export const getWrsyPointListUsingPOST = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/wrsyPointList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['wrsyQuery'] !== undefined) {
    body = parameters['wrsyQuery']
  }
  if (parameters['wrsyQuery'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wrsyQuery'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getWrsyPointListUsingPOST_RAW_URL = function () {
  return '/screen/mapPop/wrsyPointList'
}
export const getWrsyPointListUsingPOST_TYPE = function () {
  return 'post'
}
export const getWrsyPointListUsingPOSTURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/wrsyPointList'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染溯源--问题列表
 * request: getWrsyProblemListUsingPOST
 * url: getWrsyProblemListUsingPOSTURL
 * method: getWrsyProblemListUsingPOST_TYPE
 * raw_url: getWrsyProblemListUsingPOST_RAW_URL
 * @param wrsyProblemQuery - wrsyProblemQuery
 */
export const getWrsyProblemListUsingPOST = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/wrsyProblemList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['wrsyProblemQuery'] !== undefined) {
    body = parameters['wrsyProblemQuery']
  }
  if (parameters['wrsyProblemQuery'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wrsyProblemQuery'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getWrsyProblemListUsingPOST_RAW_URL = function () {
  return '/screen/mapPop/wrsyProblemList'
}
export const getWrsyProblemListUsingPOST_TYPE = function () {
  return 'post'
}
export const getWrsyProblemListUsingPOSTURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/wrsyProblemList'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污水处理厂超标因子数据弹窗信息
 * request: wsclcCbFactorListUsingGET
 * url: wsclcCbFactorListUsingGETURL
 * method: wsclcCbFactorListUsingGET_TYPE
 * raw_url: wsclcCbFactorListUsingGET_RAW_URL
 * @param endTime - yyyy-MM-dd HH
 * @param outPutCode - 排口编码
 * @param startTime - yyyy-MM-dd HH
 * @param timeUnit - 时间单位：(hour:小时, day:天)
 */
export const wsclcCbFactorListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/wsclcCbFactor'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['endTime'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: endTime'))
  }
  if (parameters['outPutCode'] !== undefined) {
    queryParameters['outPutCode'] = parameters['outPutCode']
  }
  if (parameters['outPutCode'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: outPutCode'))
  }
  if (parameters['startTime'] !== undefined) {
    queryParameters['startTime'] = parameters['startTime']
  }
  if (parameters['startTime'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: startTime'))
  }
  if (parameters['timeUnit'] !== undefined) {
    queryParameters['timeUnit'] = parameters['timeUnit']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const wsclcCbFactorListUsingGET_RAW_URL = function () {
  return '/screen/mapPop/wsclcCbFactor'
}
export const wsclcCbFactorListUsingGET_TYPE = function () {
  return 'get'
}
export const wsclcCbFactorListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/wsclcCbFactor'
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['outPutCode'] !== undefined) {
    queryParameters['outPutCode'] = parameters['outPutCode']
  }
  if (parameters['startTime'] !== undefined) {
    queryParameters['startTime'] = parameters['startTime']
  }
  if (parameters['timeUnit'] !== undefined) {
    queryParameters['timeUnit'] = parameters['timeUnit']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污水处理厂弹窗信息
 * request: wsclcDetailInfoUsingGET
 * url: wsclcDetailInfoUsingGETURL
 * method: wsclcDetailInfoUsingGET_TYPE
 * raw_url: wsclcDetailInfoUsingGET_RAW_URL
 * @param outPutCode - 排口编码
 * @param psCode - 污水处理厂编码
 * @param stmc - 水体名称
 */
export const wsclcDetailInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/wsclcDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['outPutCode'] !== undefined) {
    queryParameters['outPutCode'] = parameters['outPutCode']
  }
  if (parameters['psCode'] !== undefined) {
    queryParameters['psCode'] = parameters['psCode']
  }
  if (parameters['psCode'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: psCode'))
  }
  if (parameters['stmc'] !== undefined) {
    queryParameters['stmc'] = parameters['stmc']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const wsclcDetailInfoUsingGET_RAW_URL = function () {
  return '/screen/mapPop/wsclcDetail'
}
export const wsclcDetailInfoUsingGET_TYPE = function () {
  return 'get'
}
export const wsclcDetailInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/wsclcDetail'
  if (parameters['outPutCode'] !== undefined) {
    queryParameters['outPutCode'] = parameters['outPutCode']
  }
  if (parameters['psCode'] !== undefined) {
    queryParameters['psCode'] = parameters['psCode']
  }
  if (parameters['stmc'] !== undefined) {
    queryParameters['stmc'] = parameters['stmc']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 畜牧养殖弹窗信息
 * request: getXmyzDetailUsingGET
 * url: getXmyzDetailUsingGETURL
 * method: getXmyzDetailUsingGET_TYPE
 * raw_url: getXmyzDetailUsingGET_RAW_URL
 * @param id - id
 */
export const getXmyzDetailUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/xmyzDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getXmyzDetailUsingGET_RAW_URL = function () {
  return '/screen/mapPop/xmyzDetail'
}
export const getXmyzDetailUsingGET_TYPE = function () {
  return 'get'
}
export const getXmyzDetailUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/xmyzDetail'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 一体化自动站弹窗信息
 * request: detailWithMnUsingGET
 * url: detailWithMnUsingGETURL
 * method: detailWithMnUsingGET_TYPE
 * raw_url: detailWithMnUsingGET_RAW_URL
 * @param id - 设备mn
 */
export const detailWithMnUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/ythzdzDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const detailWithMnUsingGET_RAW_URL = function () {
  return '/screen/mapPop/ythzdzDetail'
}
export const detailWithMnUsingGET_TYPE = function () {
  return 'get'
}
export const detailWithMnUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/ythzdzDetail'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 饮用水源地弹窗信息
 * request: getYySydDetailUsingGET
 * url: getYySydDetailUsingGETURL
 * method: getYySydDetailUsingGET_TYPE
 * raw_url: getYySydDetailUsingGET_RAW_URL
 * @param id - id
 */
export const getYySydDetailUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/yysydDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getYySydDetailUsingGET_RAW_URL = function () {
  return '/screen/mapPop/yysydDetail'
}
export const getYySydDetailUsingGET_TYPE = function () {
  return 'get'
}
export const getYySydDetailUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/yysydDetail'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 重点工业企业弹窗信息
 * request: zdgyqyDetailInfoUsingGET
 * url: zdgyqyDetailInfoUsingGETURL
 * method: zdgyqyDetailInfoUsingGET_TYPE
 * raw_url: zdgyqyDetailInfoUsingGET_RAW_URL
 * @param outPutCode - 排口编码
 * @param psCode - 重点工业企业编码
 */
export const zdgyqyDetailInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/mapPop/zdgyqyDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['outPutCode'] !== undefined) {
    queryParameters['outPutCode'] = parameters['outPutCode']
  }
  if (parameters['psCode'] !== undefined) {
    queryParameters['psCode'] = parameters['psCode']
  }
  if (parameters['psCode'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: psCode'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const zdgyqyDetailInfoUsingGET_RAW_URL = function () {
  return '/screen/mapPop/zdgyqyDetail'
}
export const zdgyqyDetailInfoUsingGET_TYPE = function () {
  return 'get'
}
export const zdgyqyDetailInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/mapPop/zdgyqyDetail'
  if (parameters['outPutCode'] !== undefined) {
    queryParameters['outPutCode'] = parameters['outPutCode']
  }
  if (parameters['psCode'] !== undefined) {
    queryParameters['psCode'] = parameters['psCode']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 饮用水源地统计
 * request: drinkingWaterSourceCountUsingGET
 * url: drinkingWaterSourceCountUsingGETURL
 * method: drinkingWaterSourceCountUsingGET_TYPE
 * raw_url: drinkingWaterSourceCountUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 数据月份 yyyy-MM
 */
export const drinkingWaterSourceCountUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/reservoirSafety/drinkingWaterSourceCount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const drinkingWaterSourceCountUsingGET_RAW_URL = function () {
  return '/screen/reservoirSafety/drinkingWaterSourceCount'
}
export const drinkingWaterSourceCountUsingGET_TYPE = function () {
  return 'get'
}
export const drinkingWaterSourceCountUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/reservoirSafety/drinkingWaterSourceCount'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 饮用水源地筛选列表
 * request: drinkingWaterSourceListUsingGET
 * url: drinkingWaterSourceListUsingGETURL
 * method: drinkingWaterSourceListUsingGET_TYPE
 * raw_url: drinkingWaterSourceListUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 数据月份 yyyy-MM
 * @param sectionName - 站点名称
 * @param zdlx - 站点类型
 */
export const drinkingWaterSourceListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/reservoirSafety/drinkingWaterSourceList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['sectionName'] !== undefined) {
    queryParameters['sectionName'] = parameters['sectionName']
  }
  if (parameters['zdlx'] !== undefined) {
    queryParameters['zdlx'] = parameters['zdlx']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const drinkingWaterSourceListUsingGET_RAW_URL = function () {
  return '/screen/reservoirSafety/drinkingWaterSourceList'
}
export const drinkingWaterSourceListUsingGET_TYPE = function () {
  return 'get'
}
export const drinkingWaterSourceListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/reservoirSafety/drinkingWaterSourceList'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['sectionName'] !== undefined) {
    queryParameters['sectionName'] = parameters['sectionName']
  }
  if (parameters['zdlx'] !== undefined) {
    queryParameters['zdlx'] = parameters['zdlx']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水库信息统计
 * request: reservoirCountUsingGET
 * url: reservoirCountUsingGETURL
 * method: reservoirCountUsingGET_TYPE
 * raw_url: reservoirCountUsingGET_RAW_URL
 * @param ly - 流域
 */
export const reservoirCountUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/reservoirSafety/reservoirCount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const reservoirCountUsingGET_RAW_URL = function () {
  return '/screen/reservoirSafety/reservoirCount'
}
export const reservoirCountUsingGET_TYPE = function () {
  return 'get'
}
export const reservoirCountUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/reservoirSafety/reservoirCount'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水库点位信息
 * request: reservoirInfoUsingGET
 * url: reservoirInfoUsingGETURL
 * method: reservoirInfoUsingGET_TYPE
 * raw_url: reservoirInfoUsingGET_RAW_URL
 * @param ly - 流域
 * @param reservoirType - 水库类型 小型，中型
 * @param type - 水库，饮用水源地
 */
export const reservoirInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/reservoirSafety/reservoirInfo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['reservoirType'] !== undefined) {
    queryParameters['reservoirType'] = parameters['reservoirType']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const reservoirInfoUsingGET_RAW_URL = function () {
  return '/screen/reservoirSafety/reservoirInfo'
}
export const reservoirInfoUsingGET_TYPE = function () {
  return 'get'
}
export const reservoirInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/reservoirSafety/reservoirInfo'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['reservoirType'] !== undefined) {
    queryParameters['reservoirType'] = parameters['reservoirType']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水库工程检查次数统计
 * request: reservoirProjectCheckCountUsingGET
 * url: reservoirProjectCheckCountUsingGETURL
 * method: reservoirProjectCheckCountUsingGET_TYPE
 * raw_url: reservoirProjectCheckCountUsingGET_RAW_URL
 * @param end - 结束时间 2021-01-02
 * @param ly - 流域
 * @param start - 开始时间 2021-01-01
 */
export const reservoirProjectCheckCountUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/reservoirSafety/reservoirProjectCheckCount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['end'] !== undefined) {
    queryParameters['end'] = parameters['end']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['start'] !== undefined) {
    queryParameters['start'] = parameters['start']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const reservoirProjectCheckCountUsingGET_RAW_URL = function () {
  return '/screen/reservoirSafety/reservoirProjectCheckCount'
}
export const reservoirProjectCheckCountUsingGET_TYPE = function () {
  return 'get'
}
export const reservoirProjectCheckCountUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/reservoirSafety/reservoirProjectCheckCount'
  if (parameters['end'] !== undefined) {
    queryParameters['end'] = parameters['end']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['start'] !== undefined) {
    queryParameters['start'] = parameters['start']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水库工程检查人员统计
 * request: reservoirProjectCheckPersonCountUsingGET
 * url: reservoirProjectCheckPersonCountUsingGETURL
 * method: reservoirProjectCheckPersonCountUsingGET_TYPE
 * raw_url: reservoirProjectCheckPersonCountUsingGET_RAW_URL
 * @param ly - 流域
 */
export const reservoirProjectCheckPersonCountUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/reservoirSafety/reservoirProjectCheckPersonCount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const reservoirProjectCheckPersonCountUsingGET_RAW_URL = function () {
  return '/screen/reservoirSafety/reservoirProjectCheckPersonCount'
}
export const reservoirProjectCheckPersonCountUsingGET_TYPE = function () {
  return 'get'
}
export const reservoirProjectCheckPersonCountUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/reservoirSafety/reservoirProjectCheckPersonCount'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水库工程安全问题统计
 * request: reservoirProjectProblemCountUsingGET
 * url: reservoirProjectProblemCountUsingGETURL
 * method: reservoirProjectProblemCountUsingGET_TYPE
 * raw_url: reservoirProjectProblemCountUsingGET_RAW_URL
 * @param ly - 流域
 */
export const reservoirProjectProblemCountUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/reservoirSafety/reservoirProjectProblemCount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const reservoirProjectProblemCountUsingGET_RAW_URL = function () {
  return '/screen/reservoirSafety/reservoirProjectProblemCount'
}
export const reservoirProjectProblemCountUsingGET_TYPE = function () {
  return 'get'
}
export const reservoirProjectProblemCountUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/reservoirSafety/reservoirProjectProblemCount'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 湖库水质监测
 * request: waterQualityMonitoringUsingGET
 * url: waterQualityMonitoringUsingGETURL
 * method: waterQualityMonitoringUsingGET_TYPE
 * raw_url: waterQualityMonitoringUsingGET_RAW_URL
 * @param ly - 流域
 */
export const waterQualityMonitoringUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/reservoirSafety/waterQualityMonitoring'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const waterQualityMonitoringUsingGET_RAW_URL = function () {
  return '/screen/reservoirSafety/waterQualityMonitoring'
}
export const waterQualityMonitoringUsingGET_TYPE = function () {
  return 'get'
}
export const waterQualityMonitoringUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/reservoirSafety/waterQualityMonitoring'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 问题列表-紧急程度下拉
 * request: emergencyDegreeDropBoxUsingGET
 * url: emergencyDegreeDropBoxUsingGETURL
 * method: emergencyDegreeDropBoxUsingGET_TYPE
 * raw_url: emergencyDegreeDropBoxUsingGET_RAW_URL
 */
export const emergencyDegreeDropBoxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/river_chief/emergencyDegreeDropBox'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const emergencyDegreeDropBoxUsingGET_RAW_URL = function () {
  return '/screen/river_chief/emergencyDegreeDropBox'
}
export const emergencyDegreeDropBoxUsingGET_TYPE = function () {
  return 'get'
}
export const emergencyDegreeDropBoxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/river_chief/emergencyDegreeDropBox'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 措施/责任清单
 * request: getProblemMeasuresListUsingGET
 * url: getProblemMeasuresListUsingGETURL
 * method: getProblemMeasuresListUsingGET_TYPE
 * raw_url: getProblemMeasuresListUsingGET_RAW_URL
 * @param beginTime - 任务开始时间:2021
 * @param endTime - 任务结束时间:2025
 * @param ly - 流域
 * @param problemLevel - 问题级别--1:市级  2:区级
 * @param problemType - 问题类别--1:水资源保护 2:水域岸线管理保护 3:水污染防治 4:水环境治理 5:水生态修复 6:执法监管
 */
export const getProblemMeasuresListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/river_chief/getProblemMeasuresList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['problemLevel'] !== undefined) {
    queryParameters['problemLevel'] = parameters['problemLevel']
  }
  if (parameters['problemType'] !== undefined) {
    queryParameters['problemType'] = parameters['problemType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProblemMeasuresListUsingGET_RAW_URL = function () {
  return '/screen/river_chief/getProblemMeasuresList'
}
export const getProblemMeasuresListUsingGET_TYPE = function () {
  return 'get'
}
export const getProblemMeasuresListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/river_chief/getProblemMeasuresList'
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['problemLevel'] !== undefined) {
    queryParameters['problemLevel'] = parameters['problemLevel']
  }
  if (parameters['problemType'] !== undefined) {
    queryParameters['problemType'] = parameters['problemType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 沿程水质接口(当月数据)
 * request: getYcszUsingGET
 * url: getYcszUsingGETURL
 * method: getYcszUsingGET_TYPE
 * raw_url: getYcszUsingGET_RAW_URL
 * @param ly - ly
 * @param type - type
 */
export const getYcszUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/river_chief/getYcsz'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getYcszUsingGET_RAW_URL = function () {
  return '/screen/river_chief/getYcsz'
}
export const getYcszUsingGET_TYPE = function () {
  return 'get'
}
export const getYcszUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/river_chief/getYcsz'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 沿程水质类型下拉框
 * request: getYcszTypeDropBoxUsingGET
 * url: getYcszTypeDropBoxUsingGETURL
 * method: getYcszTypeDropBoxUsingGET_TYPE
 * raw_url: getYcszTypeDropBoxUsingGET_RAW_URL
 */
export const getYcszTypeDropBoxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/river_chief/getYcszTypeDropBox'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getYcszTypeDropBoxUsingGET_RAW_URL = function () {
  return '/screen/river_chief/getYcszTypeDropBox'
}
export const getYcszTypeDropBoxUsingGET_TYPE = function () {
  return 'get'
}
export const getYcszTypeDropBoxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/river_chief/getYcszTypeDropBox'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 问题详情(含处理流程)
 * request: wgyWtInfoUsingGET_1
 * url: wgyWtInfoUsingGET_1URL
 * method: wgyWtInfoUsingGET_1_TYPE
 * raw_url: wgyWtInfoUsingGET_1_RAW_URL
 * @param id - 问题id
 */
export const wgyWtInfoUsingGET_1 = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/river_chief/problemDetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const wgyWtInfoUsingGET_1_RAW_URL = function () {
  return '/screen/river_chief/problemDetail'
}
export const wgyWtInfoUsingGET_1_TYPE = function () {
  return 'get'
}
export const wgyWtInfoUsingGET_1URL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/river_chief/problemDetail'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 问题列表
 * request: getProblemListUsingGET
 * url: getProblemListUsingGETURL
 * method: getProblemListUsingGET_TYPE
 * raw_url: getProblemListUsingGET_RAW_URL
 * @param emergencyDegree - 紧急程度
 * @param problemType - 问题类别
 */
export const getProblemListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/river_chief/problemList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['problemStatus'] !== undefined) {
    queryParameters['problemStatus'] = parameters['problemStatus']
  }
  if (parameters['problemType'] !== undefined) {
    queryParameters['problemType'] = parameters['problemType']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProblemListUsingGET_RAW_URL = function () {
  return '/screen/river_chief/problemList'
}
export const getProblemListUsingGET_TYPE = function () {
  return 'get'
}
export const getProblemListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/river_chief/problemList'
  if (parameters['emergencyDegree'] !== undefined) {
    queryParameters['emergencyDegree'] = parameters['emergencyDegree']
  }
  if (parameters['problemType'] !== undefined) {
    queryParameters['problemType'] = parameters['problemType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 问题列表（new）
 * request: getProblemListDispatch
 * url: getProblemListGETURL
 * @param emergencyDegree - 紧急程度
 * @param problemType - 问题类别
 * @param problemName - 模糊搜索
 * @param beginTime - 开始时间
 * @param endTime - 结束时间
 * @param pageSize - 分页
 * @param ly - 流域
 */
export const getProblemListDispatch = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/shijudaping/problemList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['problemStatus'] !== undefined) {
    queryParameters['problemStatus'] = parameters['problemStatus']
  }
  if (parameters['problemType'] !== undefined) {
    queryParameters['problemType'] = parameters['problemType']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters['beginTime'] !== undefined) {
    queryParameters['beginTime'] = parameters['beginTime']
  }
  if (parameters['endTime'] !== undefined) {
    queryParameters['endTime'] = parameters['endTime']
  }
  if (parameters['problemName'] !== undefined) {
    queryParameters['problemName'] = parameters['problemName']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
/**
 * 问题列表-问题类别下拉
 * request: problemTypeDropBoxUsingGET
 * url: problemTypeDropBoxUsingGETURL
 * method: problemTypeDropBoxUsingGET_TYPE
 * raw_url: problemTypeDropBoxUsingGET_RAW_URL
 */
export const problemTypeDropBoxUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/river_chief/problemTypeDropBox'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const problemTypeDropBoxUsingGET_RAW_URL = function () {
  return '/screen/river_chief/problemTypeDropBox'
}
export const problemTypeDropBoxUsingGET_TYPE = function () {
  return 'get'
}
export const problemTypeDropBoxUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/river_chief/problemTypeDropBox'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 巡河问题统计
 * request: xhwtStatisticsUsingGET
 * url: xhwtStatisticsUsingGETURL
 * method: xhwtStatisticsUsingGET_TYPE
 * raw_url: xhwtStatisticsUsingGET_RAW_URL
 * @param ly - ly
 */
export const xhwtStatisticsUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/river_chief/xhwtStatistics'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const xhwtStatisticsUsingGET_RAW_URL = function () {
  return '/screen/river_chief/xhwtStatistics'
}
export const xhwtStatisticsUsingGET_TYPE = function () {
  return 'get'
}
export const xhwtStatisticsUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/river_chief/xhwtStatistics'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 断面 年度和上年 评价级别列表查询接口
 * request: GkSkWaterUsingGET
 * url: GkSkWaterUsingGETURL
 * method: GkSkWaterUsingGET_TYPE
 * raw_url: GkSkWaterUsingGET_RAW_URL
 * @param sectionId - 断面ID
 * @param year - 今年年份 时间格式（yyyy）
 */
export const GkSkWaterUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/GkSkWater'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['sectionId'] !== undefined) {
    queryParameters['sectionID'] = parameters['sectionId']
  }
  if (parameters['sectionId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sectionId'))
  }
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters['year'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: year'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const GkSkWaterUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/GkSkWater'
}
export const GkSkWaterUsingGET_TYPE = function () {
  return 'get'
}
export const GkSkWaterUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/GkSkWater'
  if (parameters['sectionId'] !== undefined) {
    queryParameters['sectionID'] = parameters['sectionId']
  }
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 水质实况
 * request: WaterDetectionSiteDistributionByFourUsingGET
 * url: WaterDetectionSiteDistributionByFourUsingGETURL
 * method: WaterDetectionSiteDistributionByFourUsingGET_TYPE
 * raw_url: WaterDetectionSiteDistributionByFourUsingGET_RAW_URL
 * @param date - 时间格式（yyyy-MM-dd HH）
 * @param ly - 流域
 */
export const WaterDetectionSiteDistributionByFourUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/WaterDetectionSiteDistributionByFour'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['date'] !== undefined) {
    queryParameters['date'] = parameters['date']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const WaterDetectionSiteDistributionByFourUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/WaterDetectionSiteDistributionByFour'
}
export const WaterDetectionSiteDistributionByFourUsingGET_TYPE = function () {
  return 'get'
}
export const WaterDetectionSiteDistributionByFourUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/WaterDetectionSiteDistributionByFour'
  if (parameters['date'] !== undefined) {
    queryParameters['date'] = parameters['date']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 自动监测站统计信息查询接口
 * request: WaterStandardRateUsingGET
 * url: WaterStandardRateUsingGETURL
 * method: WaterStandardRateUsingGET_TYPE
 * raw_url: WaterStandardRateUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 时间格式（yyyy-MM）
 */
export const WaterStandardRateUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/WaterStandardRate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const WaterStandardRateUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/WaterStandardRate'
}
export const WaterStandardRateUsingGET_TYPE = function () {
  return 'get'
}
export const WaterStandardRateUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/WaterStandardRate'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 自动站水质评价(12小时内)
 * request: getAutoSiteYcszByTwelveHourUsingGET
 * url: getAutoSiteYcszByTwelveHourUsingGETURL
 * method: getAutoSiteYcszByTwelveHourUsingGET_TYPE
 * raw_url: getAutoSiteYcszByTwelveHourUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getAutoSiteYcszByTwelveHourUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/autoSiteYcszByTwelveHour'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAutoSiteYcszByTwelveHourUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/autoSiteYcszByTwelveHour'
}
export const getAutoSiteYcszByTwelveHourUsingGET_TYPE = function () {
  return 'get'
}
export const getAutoSiteYcszByTwelveHourUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/autoSiteYcszByTwelveHour'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 点击数量返回对应点位信息 | 自动监测站-点击数量返回对应点位信息
 * request: automaticMonitoringStationTreedUsingGET
 * url: automaticMonitoringStationTreedUsingGETURL
 * method: automaticMonitoringStationTreedUsingGET_TYPE
 * raw_url: automaticMonitoringStationTreedUsingGET_RAW_URL
 * @param kh - 考核（1-国考，3-市考,5-镇街考）
 * @param zdlx - 一体化水质自动监测站, 物联型水质自动监测站, 其它
 */
export const automaticMonitoringStationTreedUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/automaticMonitoringStationTreed'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['kh'] !== undefined) {
    queryParameters['kh'] = parameters['kh']
  }
  if (parameters['zdlx'] !== undefined) {
    queryParameters['zdlx'] = parameters['zdlx']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const automaticMonitoringStationTreedUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/automaticMonitoringStationTreed'
}
export const automaticMonitoringStationTreedUsingGET_TYPE = function () {
  return 'get'
}
export const automaticMonitoringStationTreedUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/automaticMonitoringStationTreed'
  if (parameters['kh'] !== undefined) {
    queryParameters['kh'] = parameters['kh']
  }
  if (parameters['zdlx'] !== undefined) {
    queryParameters['zdlx'] = parameters['zdlx']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 手工监测断面统计
 * request: waterAssessmentUsingGET_1
 * url: waterAssessmentUsingGET_1URL
 * method: waterAssessmentUsingGET_1_TYPE
 * raw_url: waterAssessmentUsingGET_1_RAW_URL
 * @param ly - 流域
 * @param month - 时间格式（yyyy-MM）
 */
export const waterAssessmentUsingGET_1 = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const waterAssessmentUsingGET_1_RAW_URL = function () {
  return '/screen/waterAssessment/count'
}
export const waterAssessmentUsingGET_1_TYPE = function () {
  return 'get'
}
export const waterAssessmentUsingGET_1URL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/count'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 点击点位获取相关断面信息
 * request: waterAssessmentByIdUsingGET_1
 * url: waterAssessmentByIdUsingGET_1URL
 * method: waterAssessmentByIdUsingGET_1_TYPE
 * raw_url: waterAssessmentByIdUsingGET_1_RAW_URL
 * @param id - 断面id
 */
export const waterAssessmentByIdUsingGET_1 = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/dmTreed'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const waterAssessmentByIdUsingGET_1_RAW_URL = function () {
  return '/screen/waterAssessment/dmTreed'
}
export const waterAssessmentByIdUsingGET_1_TYPE = function () {
  return 'get'
}
export const waterAssessmentByIdUsingGET_1URL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/dmTreed'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 点击数量返回对应点位信息 | 河流水质-点击数量返回对应点位信息
 * request: waterAssessmentGetIndexUsingGET
 * url: waterAssessmentGetIndexUsingGETURL
 * method: waterAssessmentGetIndexUsingGET_TYPE
 * raw_url: waterAssessmentGetIndexUsingGET_RAW_URL
 * @param ly - 流域
 * @param model - 达标（db），超标（cb）
 * @param month - 时间格式（yyyy-MM）
 * @param type - 国考（g），市考（s），区考（q）
 */
export const waterAssessmentGetIndexUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/getIndex'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['model'] !== undefined) {
    queryParameters['model'] = parameters['model']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['type'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: type'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const waterAssessmentGetIndexUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/getIndex'
}
export const waterAssessmentGetIndexUsingGET_TYPE = function () {
  return 'get'
}
export const waterAssessmentGetIndexUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/getIndex'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['model'] !== undefined) {
    queryParameters['model'] = parameters['model']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 自动站沿程水质（水质类别月历表）
 * request: getWterOfClassificationUsingGET
 * url: getWterOfClassificationUsingGETURL
 * method: getWterOfClassificationUsingGET_TYPE
 * raw_url: getWterOfClassificationUsingGET_RAW_URL
 * @param ly - 流域
 * @param time - 时间 (年)
 */
export const getWterOfClassificationUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/getWterOfClassification'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWterOfClassificationUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/getWterOfClassification'
}
export const getWterOfClassificationUsingGET_TYPE = function () {
  return 'get'
}
export const getWterOfClassificationUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/getWterOfClassification'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 手工断面沿程水质
 * request: getWterOfClassificationHindUsingGET
 * url: getWterOfClassificationHindUsingGETURL
 * method: getWterOfClassificationHindUsingGET_TYPE
 * raw_url: getWterOfClassificationHindUsingGET_RAW_URL
 * @param ly - 流域
 * @param time - 时间 (年月)
 */
export const getWterOfClassificationHindUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/getWterOfClassificationHind'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWterOfClassificationHindUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/getWterOfClassificationHind'
}
export const getWterOfClassificationHindUsingGET_TYPE = function () {
  return 'get'
}
export const getWterOfClassificationHindUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/getWterOfClassificationHind'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 自动站沿程水质（水质评价）
 * request: getZdzWaterAssessUsingGET
 * url: getZdzWaterAssessUsingGETURL
 * method: getZdzWaterAssessUsingGET_TYPE
 * raw_url: getZdzWaterAssessUsingGET_RAW_URL
 * @param ly - 流域
 * @param time - 时间 (年)
 */
export const getZdzWaterAssessUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/getZdzWaterAssess'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getZdzWaterAssessUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/getZdzWaterAssess'
}
export const getZdzWaterAssessUsingGET_TYPE = function () {
  return 'get'
}
export const getZdzWaterAssessUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/getZdzWaterAssess'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['time'] !== undefined) {
    queryParameters['time'] = parameters['time']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 自动站沿程水质（除水质评价）
 * request: getZdzWaterTrendUsingGET
 * url: getZdzWaterTrendUsingGETURL
 * method: getZdzWaterTrendUsingGET_TYPE
 * raw_url: getZdzWaterTrendUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getZdzWaterTrendUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/getZdzWaterTrend'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getZdzWaterTrendUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/getZdzWaterTrend'
}
export const getZdzWaterTrendUsingGET_TYPE = function () {
  return 'get'
}
export const getZdzWaterTrendUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/getZdzWaterTrend'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 断面信息查询接口
 * request: sectionInfoUsingGET
 * url: sectionInfoUsingGETURL
 * method: sectionInfoUsingGET_TYPE
 * raw_url: sectionInfoUsingGET_RAW_URL
 * @param ly - 流域
 * @param month - 月份 时间格式（yyyy-MM）
 * @param sectionType - 断面类型
 */
export const sectionInfoUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterAssessment/sectionInfo'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters['sectionType'] !== undefined) {
    queryParameters['sectionType'] = parameters['sectionType']
  }
  if (parameters['sectionType'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sectionType'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const sectionInfoUsingGET_RAW_URL = function () {
  return '/screen/waterAssessment/sectionInfo'
}
export const sectionInfoUsingGET_TYPE = function () {
  return 'get'
}
export const sectionInfoUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterAssessment/sectionInfo'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['sectionType'] !== undefined) {
    queryParameters['sectionType'] = parameters['sectionType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染源排放统计
 * request: emissionStatisticsUsingGET
 * url: emissionStatisticsUsingGETURL
 * method: emissionStatisticsUsingGET_TYPE
 * raw_url: emissionStatisticsUsingGET_RAW_URL
 * @param place - 地区
 * @param timeUnit - 时间单位,day日，month月，year年
 */
export const emissionStatisticsUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterPollution/emissionStatistics'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['place'] !== undefined) {
    queryParameters['place'] = parameters['place']
  }
  if (parameters['timeUnit'] !== undefined) {
    queryParameters['timeUnit'] = parameters['timeUnit']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const emissionStatisticsUsingGET_RAW_URL = function () {
  return '/screen/waterPollution/emissionStatistics'
}
export const emissionStatisticsUsingGET_TYPE = function () {
  return 'get'
}
export const emissionStatisticsUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterPollution/emissionStatistics'
  if (parameters['place'] !== undefined) {
    queryParameters['place'] = parameters['place']
  }
  if (parameters['timeUnit'] !== undefined) {
    queryParameters['timeUnit'] = parameters['timeUnit']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染源占比查询接口
 * request: getPollutionStatisticsUsingGET
 * url: getPollutionStatisticsUsingGETURL
 * method: getPollutionStatisticsUsingGET_TYPE
 * raw_url: getPollutionStatisticsUsingGET_RAW_URL
 * @param ly - 流域
 */
export const getPollutionStatisticsUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterPollution/getPollutionStatistics'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPollutionStatisticsUsingGET_RAW_URL = function () {
  return '/screen/waterPollution/getPollutionStatistics'
}
export const getPollutionStatisticsUsingGET_TYPE = function () {
  return 'get'
}
export const getPollutionStatisticsUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterPollution/getPollutionStatistics'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 获取污染源基本信息
 * request: getWsclcListUsingGET
 * url: getWsclcListUsingGETURL
 * method: getWsclcListUsingGET_TYPE
 * raw_url: getWsclcListUsingGET_RAW_URL
 * @param jr - 是否接入 (1-接入，0-没接入)
 * @param ly - 流域名称
 * @param online - 是否在线(1-在线,2-离线)
 * @param type - 类型（1-污水处理厂，2-重点污染源
 */
export const getWsclcListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterPollution/getWsclcList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['jr'] !== undefined) {
    queryParameters['jr'] = parameters['jr']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['online'] !== undefined) {
    queryParameters['online'] = parameters['online']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWsclcListUsingGET_RAW_URL = function () {
  return '/screen/waterPollution/getWsclcList'
}
export const getWsclcListUsingGET_TYPE = function () {
  return 'get'
}
export const getWsclcListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterPollution/getWsclcList'
  if (parameters['jr'] !== undefined) {
    queryParameters['jr'] = parameters['jr']
  }
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['online'] !== undefined) {
    queryParameters['online'] = parameters['online']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染源问题列表
 * request: listPollutionProblemUsingGET
 * url: listPollutionProblemUsingGETURL
 * method: listPollutionProblemUsingGET_TYPE
 * raw_url: listPollutionProblemUsingGET_RAW_URL
 * @param ly - ly
 * @param pageNum - pageNum
 */
export const listPollutionProblemUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterPollution/listPollutionProblem'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['pageNum'] !== undefined) {
    queryParameters['pageNum'] = parameters['pageNum']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const listPollutionProblemUsingGET_RAW_URL = function () {
  return '/screen/waterPollution/listPollutionProblem'
}
export const listPollutionProblemUsingGET_TYPE = function () {
  return 'get'
}
export const listPollutionProblemUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterPollution/listPollutionProblem'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters['pageNum'] !== undefined) {
    queryParameters['pageNum'] = parameters['pageNum']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染源问题分地点统计
 * request: pollutionProblemCountUsingGET
 * url: pollutionProblemCountUsingGETURL
 * method: pollutionProblemCountUsingGET_TYPE
 * raw_url: pollutionProblemCountUsingGET_RAW_URL
 * @param ly - ly
 */
export const pollutionProblemCountUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterPollution/pollutionProblemCount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const pollutionProblemCountUsingGET_RAW_URL = function () {
  return '/screen/waterPollution/pollutionProblemCount'
}
export const pollutionProblemCountUsingGET_TYPE = function () {
  return 'get'
}
export const pollutionProblemCountUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterPollution/pollutionProblemCount'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染源在线统计情况
 * request: wsclcStatisticalOnlineUsingGET
 * url: wsclcStatisticalOnlineUsingGETURL
 * method: wsclcStatisticalOnlineUsingGET_TYPE
 * raw_url: wsclcStatisticalOnlineUsingGET_RAW_URL
 * @param ly - 流域名称
 */
export const wsclcStatisticalOnlineUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterPollution/wsclc/statistical/online'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const wsclcStatisticalOnlineUsingGET_RAW_URL = function () {
  return '/screen/waterPollution/wsclc/statistical/online'
}
export const wsclcStatisticalOnlineUsingGET_TYPE = function () {
  return 'get'
}
export const wsclcStatisticalOnlineUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterPollution/wsclc/statistical/online'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 污染源排放实时监测
 * request: wsclcDatasUsingGET
 * url: wsclcDatasUsingGETURL
 * method: wsclcDatasUsingGET_TYPE
 * raw_url: wsclcDatasUsingGET_RAW_URL
 * @param ly - ly
 */
export const wsclcDatasUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/waterPollution/wsclc/wsclcDatas'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const wsclcDatasUsingGET_RAW_URL = function () {
  return '/screen/waterPollution/wsclc/wsclcDatas'
}
export const wsclcDatasUsingGET_TYPE = function () {
  return 'get'
}
export const wsclcDatasUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/waterPollution/wsclc/wsclcDatas'
  if (parameters['ly'] !== undefined) {
    queryParameters['ly'] = parameters['ly']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
/**
 * 无人机地图上展示数据
 * request: getWrjPathListUsingGET
 * url: getWrjPathListUsingGETURL
 * method: getWrjPathListUsingGET_TYPE
 * raw_url: getWrjPathListUsingGET_RAW_URL
 */
export const getWrjPathListUsingGET = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/wrj/wrjPathList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWrjPathListUsingGET_RAW_URL = function () {
  return '/wrj/wrjPathList'
}
export const getWrjPathListUsingGET_TYPE = function () {
  return 'get'
}
export const getWrjPathListUsingGETURL = function (parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/wrj/wrjPathList'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&')
      : '')
  )
}
